module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/how-to-enjoy-sola-03-97c0e2fc1108f15dd7d3357c2cc8402c.jpg";